<template>
  <div>
    <div class="bg-white rounded-sm m-2">
      <b-row>
        <b-col cols="12" class="m-2">
          <b-row>
            <b-col cols="6">
              <span class="text-xs px-2 py-1 text-red">
                <b>{{ getRestorationsCount.total }}</b> Total Submissions
              </span>
              <span class="text-xs px-2 py-1 text-blue ml-2">
                <b>{{ getRestorationsCount.assigned }}</b> Assigned
              </span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <div class="bg-white rounded-sm m-2">
      <!-- FIRST BRANCH: LOADER -->
      <b-row class="mx-1 py-2" v-if="showNextLoader">
        <b-col cols="12">
          <TaskLoader ref="taskLoader" v-on:nextTask="nextTask" />
        </b-col>
      </b-row>

      <!-- SECOND BRANCH: CONTENT -->
      <b-row v-else>
        <b-col cols="12">
          <b-overlay :show="loading" rounded="sm">

            <!-- EMPTY STATE -->
            <b-row v-if="!hasTask">
              <b-col cols="12" class="py-5 text-center">

                <img
                  :src="require('../../../../../assets/images/ic_empty_box.png')"
                  class="icon mx-auto"
                />

                <div class="h5 text-gray mx-auto mt-4">
                  There are no Restorations left in the queue
                </div>

                <div class="text-gray mx-auto mt-2">
                  Tasks will be available when clients submit new
                  <b class="text-blue">applications</b> or when
                  <b class="text-orange">queries</b> are responded to.
                </div>

                <button
                  class="text-white bg-blue rounded-md px-2 py-2 mt-4 mx-auto hover:bg-blue-dark"
                  @click="checkForUpdates"
                >
                  Check for Updates
                </button>

              </b-col>
            </b-row>

            <!-- TASK STATE -->
            <b-row v-else>
              <b-col cols="12">
                <b-row class="mx-1 py-2">
                  <b-col cols="6">
                    <span class="bg-blue text-white px-2 py-1 rounded-sm text-xs font-bold">
                      #CompanyRestoration
                    </span>
                  </b-col>
                </b-row>

               <CompanyRestorationTask :task="getRestorationTask" />
              </b-col>
            </b-row>

          </b-overlay>
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import CompanyRestorationTask from "@/views/home/services/restorations/task/CompanyRestorationTask";
import TaskLoader from "@/views/home/commons/TaskLoader";

export default {
  name: "RestorationTaskQueue",
  components: {
    TaskLoader,
    CompanyRestorationTask,
  },
  data() {
    return {
      loading: false,
      showNextLoader: true,
    }
  },
  mounted() {
    this.fetchRestorationCount()
    this.checkForUpdates() // First load
  },
  methods: {
    ...mapActions([
      "fetchNextRestoration",
      "fetchRestorationResponses",
      "fetchRestorationCount",
      "emptyAnalysisReport"
    ]),
    checkForUpdates() {
      this.loading = true
      this.emptyAnalysisReport()
      this.fetchNextRestoration()
    },
    nextTask() {
      this.loading = true
      this.showNextLoader = false
      this.emptyAnalysisReport()
      this.fetchNextRestoration()
    },
  },
  computed: {
    ...mapGetters([
      "getRestorationTask",
      "getRestorationsCount",
      "getRestorationActionSuccess"
    ]),

    // hasTask() {
    //   const task = this.getRestorationTask
    //   return task && task.id
    // }
    hasTask() {
    const task = this.getRestorationTask
    if (!task) return false
    let current = task
    while (current && (current.data || current.restoration)) {
      current = current.data || current.restoration
    }
    return !!current?.id
  }
  },
  watch: {
    getRestorationTask(newVal) {
      this.loading = false
      console.log("Task received:", newVal)
    },
    getRestorationActionSuccess() {
      this.loading = false
      this.showNextLoader = true
      this.emptyAnalysisReport()
      setTimeout(() => this.checkForUpdates(), 1500)
    },
  }
}
</script>

<style scoped>
@import "../../../../../assets/styles/menu.css";

.title {
  font-size: 22px;
}

.icon {
  width: 170px;
}

.btn-escalate {
  @apply border bg-orange rounded-sm text-white text-sm px-3 py-1 mx-1 bg-white;
}

.btn-escalate:hover {
  @apply bg-orange-dark;
}

.btn-approve {
  @apply border border-blue rounded-sm text-blue text-sm px-3 py-1 mx-1 bg-white;
}

.btn-query {
  @apply border border-blue rounded-sm text-blue text-sm px-3 py-1 mx-1 bg-white;
}

.btn-reject {
  @apply border border-blue rounded-sm text-blue text-sm px-3 py-1 mx-1 bg-white;
}

.btn-approve:hover {
  @apply bg-green border-green text-white;
}

.btn-query:hover {
  @apply bg-orange border-orange text-white;
}

.btn-reject:hover {
  @apply bg-red border-red text-white;
}

.btn-approve-hover {
  @apply bg-green border-green text-white mt-2 px-4 py-1 rounded-sm;
}

.btn-query-hover {
  @apply bg-orange border-orange text-white mt-2 px-4 py-1 rounded-sm;
}

.btn-reject-hover {
  @apply bg-red border-red text-white mt-2 px-4 py-1 rounded-sm;
}

.btn-approve-hover:hover {
  @apply bg-green-dark;
}

.btn-query-hover:hover {
  @apply bg-orange-dark;
}

.btn-reject-hover:hover {
  @apply bg-red-dark;
}
</style>